const BASE_PATH = '/quality/control'

export default {
  getList: query => ({
    url: `${BASE_PATH}/query/${query.siteId}/${query.deviceCategoryId}/${query.checkItemId}?beginTime=${query.beginTime.substr(0, 10)}&endTime=${query.endTime.substr(0, 10)}`,
    method: 'GET'
  }),
  getCategoryMapping: () => ({
    url: `${BASE_PATH}/query/category`,
    method: 'GET'
  }),
  updateFactorName: model => ({
    url: `${BASE_PATH}/query/factors/data`,
    data: model,
    method: 'POST'
  }),
  delete: model => ({
    url: `${BASE_PATH}/delete`,
    data: model,
    method: 'DELETE'
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/QCAnalysis.js